import { render } from "./Dashboard.vue?vue&type=template&id=4d7d65c0"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=4d7d65c0&lang=css"
script.render = render

export default script